import { useState } from "react";
import Chart from "react-apexcharts";
import "./DashboardSocialRadialBar.css";

const DashboardSocialRadialBar = () => {
  const [options] = useState({
    chart: {
      //   height: 350,
      type: "radialBar",
      //   sparkline: {
      //     enabled: true,
      //   },
    },
    grid: {
      padding: {
        left: 0,
        top: -30,
        bottom: -30,
      },
    },
    plotOptions: {
      radialBar: {
        distributed: true,
        offsetY: 30,
        hollow: {
          background: "transparent",
          size: "40%",
          margin: 0,
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            fontSize: "25px",
            fontFamily: "poppins",
            offsetY: 9,
            fontWeight: 700,
          },
          total: {
            show: true,
            formatter: function () {
              let total = 0;
              series.forEach((s) => {
                total += s;
              });
              return total / series.length + "%";
            },
          },
        },
      },
    },
    fill: {
      colors: ["#f14c64", "#1877f2", "#1d9bf0", "#31AC53"],
    },
    stroke: {
      lineCap: "round",
    },
    legend: {
      show: true,
      //   width: 600,
      horizontalAlign: "left",
      position: "top",
      labels: {
        colors: "#757679",
      },
      customLegendItems: ["Instagram", "Facebook", "Twitter", "Google"],
      fontFamily: "poppins",
      markers: {
        radius: 20,
        fillColors: ["#f14c64", "#1877f2", "#1d9bf0", "#31AC53"],
      },
    },
    labels: ["Instagram", "Facebook", "Twitter", "Google"],
   
  });
  const [series] = useState([60, 46, 40, 70]);
  return (
    <div className="dashboardSocialRadialBar">
      <Chart
        options={options}
        series={series}
        type="radialBar"
        // width="100%"
        height={220}
      />
      <p>
        Every large design company whether it’s a multi-national branding
        corporation or a regular down at heel tatty magazine publisher needs to
        fill holes in the workforce.
      </p>
    </div>
  );
};

export default DashboardSocialRadialBar;
